import React from "react";
import { AiOutlineCheckCircle, AiOutlineCloseCircle, AiOutlineInfoCircle, AiOutlineWarning } from "react-icons/ai";


const typeStyles = {
  success: {
    borderLeft: "6px solid #52c41a",
    background: "#f6ffed",
    color: "#237804",
    icon: <AiOutlineCheckCircle />,
  },
  error: {
    borderLeft: "6px solid #ff4d4f",
    background: "#fff2f0",
    color: "#a8071a",
    icon: <AiOutlineCloseCircle />,
  },
  info: {
    borderLeft: "6px solid #1890ff",
    background: "#e6f7ff",
    color: "#0958d9",
    icon: <AiOutlineInfoCircle />,
  },
  warning: {
    borderLeft: "6px solid #faad14",
    background: "#fffbe6",
    color: "#ad6800",
    icon: <AiOutlineWarning />,
  },
};

const CustomAlert = ({
  message,
  icon,
  style,
  className,
  type = "info",
  onClose,
}) => {
  const alertStyle = typeStyles[type] || typeStyles.info;
  return (
    <div
      className={`custom-alert-card shadow ${className || ""}`}
      style={{
        position: "fixed", // float above content
        top: 20, // from top of screen
        left: "50%", // center horizontally
        transform: "translateX(-50%)", // truly centered
        zIndex: 9999, // stays above everything
        display: "flex",
        alignItems: "center",
        gap: 16,
        minHeight: 64,
        maxWidth: 420,
        borderRadius: 12,
        boxShadow: "0 4px 24px rgba(0,0,0,0.08)",
        padding: "20px 32px 20px 24px",
        fontSize: 18,
        fontWeight: 500,
        ...alertStyle,
        ...style,
        animation: "fadeInUp 0.4s cubic-bezier(.4,0,.2,1)",
      }}
    >
      <span style={{ fontSize: 32, marginRight: 18 }}>
        {icon || alertStyle.icon}
      </span>
      <span style={{ flex: 1 }}>{message}</span>
      <style>{`
  @keyframes fadeInUp {
    from { opacity: 0; transform: translate(-50%, 20px); }
    to { opacity: 1; transform: translate(-50%, 0); }
  }
`}</style>

    </div>
  );
};

export default CustomAlert;
